import { useContext, useEffect, useState } from "react";
import logo_white from "../../assets/images/logo_white.png";
import logo from "../../assets/images/logo.png";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useNavigate } from "react-router-dom";
import {authService} from "../../services/authService";
import tokenService from "../../services/tokenService";
import { useAuth } from "../../hooks/useAuth";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { set } from "react-hook-form";

const Login = () => {
const {t}=useContext(LocaleContext);
const navigate=useNavigate();

const [userName,setUserName]=useState("");
const [code,setCode]=useState("");
const [error,setError]=useState("");
const [loading,setLoading]=useState(false);
const { login, isAuthenticated } = useAuth();
const [codeSent, setCodeSent] = useState(false);
const allowedCountries = ['SA', 'AE', 'KW', 'QA', 'BH', 'OM'];
const countryLabels = {
  SA: t("countrySA"),
  AE: t("countryAE"),
  QA: t("countryQA"),
  KW: t("countryKW"),
  BH: t("countryBH"),
  OM: t("countryOM"),
};

useEffect(() => {
  if (isAuthenticated) {
    navigate("/dashboard");
  }
}, []);

const handleLogin = async () => {
  try {
    if(codeSent) return;
    setLoading(true);
    setError("");
    const formData={
      userName:userName,
      code:""
    }

    const response = await authService.login(formData);

    if (!response.isSuccess) {
      setError(t(response.key));
      console.log(response);
      return;
    }
    setCodeSent(true);
    //login(response.value);

    //navigate("/dashboard");

  } catch (error) {
    setError(t("anErrorOccurredPleaseTryAgainLater"));
    console.error(error);
  } finally {
    setLoading(false);
  }
};
const handleOTP = async () => {
  try {
    setLoading(true);
    setError("");
    const formData={
      userName:userName,
      code:code
    }

    const response = await authService.verifyOTP(formData);

    if (!response.isSuccess) {
      setError(t(response.key));
      console.log(response);
      return;
    }
    login(response.value);

    navigate("/dashboard");

  } catch (error) {
    setError(t("anErrorOccurredPleaseTryAgainLater"));
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  return (
    <section className="section-login">
      <div className="row g-0">
        <div className="col-12 col-md-4">
          <div className="login-left-side">
            <div className="flex-center">
              <div className="login-logo-box">
                <img src={logo} alt="Logo" />
              </div>
            </div>
            <div className="login form">
              {!codeSent && (
                <div className="form-group">
                <label htmlFor="userName">{t("mobileNumber")}</label>
                <PhoneInput
                  international
                  defaultCountry="SA"
                  countries={allowedCountries}
                  labels={countryLabels}
                  value={userName}
                  onChange={setUserName}
                />
              </div>
              )}
              {codeSent && (
                <div className="form-group">
                  <label htmlFor="code">{t("code")}</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="####"
                    onChange={(e) => setCode(e.target.value)}
                  />
                </div>
              )}
              <div className="form-group">
                <span className="text-danger">{error}</span>
              </div>
              <div className="form-group">
                {loading && (
                  <button className="btn-default w-100 disabled">
                    {t("login")}...
                  </button>
                )}
                {!loading && !codeSent && (
                  <button onClick={handleLogin} className="btn-default w-100">
                    {t("login")}
                  </button>
                )}
                {!loading && codeSent && (
                  <button onClick={handleOTP} className="btn-default w-100">
                    {t("login")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-8">
          <div className="login-image-side flex-center">
            <div className="login-banner-image-box">
              <img src={logo_white} alt="Login Banner" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
